import { useNavigate } from "react-router-dom";

import { ProgressSpinner } from "primereact/progressspinner";
import { useEffect, useState } from "react";

import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { InputText } from "primereact/inputtext";
import { getLocalFranchiseStore, getStoreLocalData, getUserData } from "../../../utils/localStorage";
import AdminMenu from "../../AdminMenu";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { getBrandCashBook } from "../../../services/Cashbook/Cashbook";
import { getBrandStore } from "../../../services/StoreUsers/PostStoreUsers";
import StoreSelectionModal from "../../StoreSelectionModal";
import SchedularModal from "../../SchedularModal";
import { localeDateEndDate, localeDateStartDate } from "../../../constants/DateUtil/DateUtil";
import FinanceAdminMenu from "../../FinanceAdminMenu";
const { innerWidth: width, innerHeight: height } = window;


const FinanceCashbook = () => {
    const navigate = useNavigate();

    const { brandProfileData, userProfileRole } = getUserData();
    const { storeLocalData } = getStoreLocalData();

    let brandId = brandProfileData.id;
    const userRole = userProfileRole;

    const [cashbookData, setCashbookData] = useState([]);
    const [cashbookBalanceData, setCashbookBalanceData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [upDateSelectedStore, setUpDateSelectedStore] = useState([]); // Default to show all orders
    const [brandStoreData, setBrandStoreData] = useState([]);
    const [selectedStore, setSelectedStore] = useState("ALL");

    const [sortingData, setSortingData] = useState(false);

    const handleSortData = () => {
        setSortingData(!sortingData);
    };

    const [storeSelectionModalVisible, setStoreSelectionModalVisible] =
        useState(false);

    const receiveDataFromStoreSelectionModal = (selectedStore) => {
        setSelectedStore(selectedStore);
    };

    const [visible, setVisible] = useState(false);

    const [searchTerm, setSearchTerm] = useState("");

    let initialStartDate = new Date();
    // initialStartDate.setDate(1);
    // initialStartDate.setMonth(initialStartDate.getMonth()); // subtract 7 days to current date

    // If orderFilterData is available, use its start and end dates
    const [startDate, setStartDate] = useState(new Date(initialStartDate));
    let initialEndDate = new Date();
    const [endDate, setEndDate] = useState(new Date(initialEndDate));
    const [analyticsSchedularModalVisible, setAnalyticsSchedularModalVisible] =
        useState(false);
    const [schedularDate, setSchedularDate] = useState({});

    const receiveDataFromSchedularModal = ({ newSchedular }) => {
        setSchedularDate(newSchedular);
    };

    const handleCalendarModal = () => {
        setAnalyticsSchedularModalVisible(true);
    };

    // const fetchCashBook = (data) => {
    //   setLoading(true);
    //   getBrandCashBook(data)
    //     .then((response) => {
    //       if (!response.data.error) {
    //         const Res = response.data;
    //         const UseFullData =  Res.cashbookDTOList.map((item) => ({
    //           dateOfOrder: item.createdDate,
    //           particular: item.particular,
    //           module: item.module,
    //           openingBalance: item.openingBalance,
    //           receipt: item.receipt,
    //           expense: item.expense,
    //           userName: item.userName,
    //           closingBalance: item.closingBalance,
    //         }))
    //         setCashbookData(UseFullData);
    //         setCashbookBalanceData(
    //           Res.storeList
    //             .filter(
    //               (item) => item.cashbookBalance && item.cashbookBalance > 0
    //             )
    //             .map((item) => ({
    //               storeName: item.storeName,
    //               cashbookBalance: item.cashbookBalance,
    //             }))
    //         );
    //         setLoading(false);
    //       }
    //     })
    //     .catch((err) => {
    //       console.error("Error:", err);
    //     });  
    // };

    const fetchStoreOrders = (data, storeInfo) => {
        setLoading(true);
        getBrandCashBook(data)
            .then(response => {
                if (!response.data.error) {
                    const Res = response.data;
                    const formatDateLedger = (dateString) => {
                        // const parsedDate = new Date(dateString?.replace('Z', '')); // Keep the "Z" to correctly interpret UTC
                        const parsedDate = new Date(dateString)

                        return parsedDate.toLocaleString("en-GB", {
                            month: "2-digit",
                            day: "2-digit",
                            year: "2-digit",
                            hour12: true,
                            hour: "numeric",
                            minute: "2-digit",
                        });
                    };

                    const UseFullData = Res.cashbookDTOList.map((item) => ({
                        dateOfOrder: formatDateLedger(item.createdDate),
                        particular: item.particular,
                        module: item.module,
                        openingBalance: item.openingBalance,
                        receipt: item.receipt,
                        expense: item.expense,
                        userName: item.userName,
                        closingBalance: item.closingBalance,
                    }))
                    setCashbookData(UseFullData);
                    setCashbookBalanceData(
                        Res.storeList
                            .filter(item => item.cashbookBalance > 0)
                            .map(item => {
                                const matchedStore = storeInfo.find(
                                    store => store.name === item.storeName,
                                );
                                return {
                                    id: matchedStore ? matchedStore.id : null, // Add id if matched, else null
                                    storeName: item.storeName,
                                    cashbookBalance: item.cashbookBalance,
                                };
                            }),
                    );
                    setLoading(false);
                }
            })
            .catch(err => {
                console.error('Error:', err);
            });
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await getBrandStore(brandId);
                if (!response.data.error) {
                    const Res = response.data;
                    setBrandStoreData(Res);
                    const brandStoreData = response.data;
                    const storeIds = brandStoreData.map((item) => item.id);
                    const storeInfo = brandStoreData.map(item => ({
                        id: item.id,
                        name: item.storeName
                    }))
                    const data = {
                        brandId: brandId,
                        storeIds: selectedStore !== "ALL" ? [selectedStore] : [storeIds[0]],
                        sortBy: "createdDate",
                        sortOrder: sortingData ? "desc" : "asc",
                        limit: 1000000,
                        startDate: schedularDate?.startDate ? localeDateStartDate(new Date(schedularDate?.startDate)) : localeDateStartDate(new Date(startDate)),
                        endDate: schedularDate?.endDate ? localeDateEndDate(new Date(schedularDate?.endDate)) : localeDateEndDate(new Date(endDate))
                        // searchBy : particular or module
                    };
                    setSelectedStore(selectedStore !== 'ALL' ? selectedStore : storeIds[0])
                    fetchStoreOrders(data, storeInfo);
                }
            } catch (error) {
                console.error("Error:", error);
            }
        };

        const fetchFranchiseStore = async () => {
            const franchiseStore = await getLocalFranchiseStore();
            if (franchiseStore.franchiseStore !== null) {
                const Res = franchiseStore.franchiseStore.filter((item) => item.status === "ACTIVE");
                setBrandStoreData(Res);
                const storeIds = Res.map((item) => item.id);
                const storeInfo = Res.map((item) => ({
                    id: item.id,
                    name: item.storeName,
                }));
                const data = {
                    brandId: brandId,
                    storeIds:
                        selectedStore !== "ALL"
                            ? [selectedStore]
                            : [storeIds[0]],
                    sortBy: "createdDate",
                    sortOrder: sortingData ? "desc" : "asc",
                    limit: 1000000,
                    startDate: schedularDate?.startDate
                        ? localeDateStartDate(new Date(schedularDate?.startDate))
                        : localeDateStartDate(new Date(startDate)),
                    endDate: schedularDate?.endDate
                        ? localeDateEndDate(new Date(schedularDate?.endDate))
                        : localeDateEndDate(new Date(endDate)),
                    // searchBy : particular or module
                };
                setSelectedStore(
                    selectedStore !== "ALL" ? selectedStore : storeIds[0]
                );
                fetchStoreOrders(data, storeInfo);
            } else {
                setBrandStoreData([]);
                setSelectedStore([]);
            }
        };

        if (userRole === "BY_FRANCHISE_ADMIN") {
            fetchFranchiseStore();
        } else {
            fetchData();
        }
    }, [selectedStore, sortingData, schedularDate]);

    const calculateTotalDataCollection = () => {
        return cashbookBalanceData.reduce(
            (total, item) => total + item.cashbookBalance,
            0
        );
    };


    const renderPaymentModeButtons = () => {
        return brandStoreData?.map((item) => (
            <div
                key={item.id}
                style={{
                    backgroundColor: item.id === selectedStore ? "green" : "#3EB3E1",
                }}
                className="px-3 py-2 border-round-md cursor-pointer"
                onClick={() => setSelectedStore(item.id)}
            >
                <p className="text-white text-xl font-bold uppercase">
                    {item?.storeName.replace(/_/g, ' ')}
                    {item.id === selectedStore && cashbookBalanceData[0]?.cashbookBalance ? ' - ' + storeLocalData?.currencySymbol + '( ' + cashbookBalanceData[0]?.cashbookBalance.toFixed(0) + ')' : ''}
                </p>
            </div>
        ));
    };

    const filterData = (data, searchTerm) => {
        if (!searchTerm) return data; // Return full data if search is empty

        const searchLower = searchTerm.toLowerCase();

        return data.filter((item) =>
            Object.values(item).some((value) =>
                typeof value === "string" || typeof value === "number"
                    ? value.toString().toLowerCase().includes(searchLower)
                    : false
            )
        );
    };

    const filteredOrderInfoData = filterData(cashbookData, searchTerm);

    const handleClearSearch = () => {
        setSearchTerm("");
    };

    const header = (
        <div className="flex flex-wrap align-items-center justify-content-between gap-2">
            <span className="text-xl text-900 font-bold">
                Balance : {storeLocalData?.currencySymbol} {Number(cashbookBalanceData).toFixed(2)}
            </span>
        </div>
    );

    const Receipt = (
        <div >
            <span className="text-md ">
                Receipt ({storeLocalData?.currencySymbol})
            </span>
        </div>
    );

    const Expense = (
        <div >
            <span className="text-md ">
                Expense ({storeLocalData?.currencySymbol})
            </span>
        </div>
    );

    const RenderCashBook = () => {
        return (
            <DataTable
                showGridlines
                value={filteredOrderInfoData}
                paginator
                // header={header}
                rows={10}
                rowsPerPageOptions={[10, 25, 50]}
                tableStyle={{ minWidth: "50rem" }}
                scrollable
                scrollHeight={height - 160}
            >
                <Column
                    header="S No."
                    style={{ width: "80px" }}
                    body={(rowData, options) =>
                        options.rowIndex + 1}
                ></Column>
                <Column
                    field="dateOfOrder"
                    header="Date"
                    style={{ width: "100px" }}
                    body={(rowData) => rowData?.dateOfOrder?.split(",")[0]}
                />
                <Column field="particular" header="Particular"></Column>
                <Column field="customer" style={{ width: "200px" }} header="Customer Name" body={(rowData) => rowData?.particular?.split(",")[2]} />

                <Column
                    field="module"
                    header="Module"
                    style={{ width: "200px" }}
                ></Column>

                <Column
                    field="openingBalance"
                    header="Opening Balance"
                    style={{ width: "120px" }}
                ></Column>
                <Column
                    field="receipt"
                    header={Receipt}
                    style={{ width: "150px" }}
                ></Column>
                <Column
                    field="expense"
                    header={Expense}
                    style={{ width: "120px" }}
                ></Column>
                <Column
                    field="userName"
                    header="Created By"
                    style={{ width: "120px" }}
                ></Column>

                <Column
                    field="closingBalance"
                    header="Closing Balance"
                    style={{ width: "120px" }}
                ></Column>
            </DataTable>
        );
    };
    return (
        <div className="flex-1">
            <div
                className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
                style={{
                    "--surface-0": "#1752AA",
                }}
            >
                <div className="flex-1 flex ml-3 mr-3">
                    <div className="flex-1 flex ">
                        <div className="ml-3 flex justify-content-center align-items-center">
                            <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                                <i
                                    className="pi pi-angle-left"
                                    onClick={() => navigate("/")}
                                    style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                                ></i>
                            </div>
                        </div>
                        <div className="flex-1 ml-5 flex justify-content-start align-items-center">
                            <p className="text-white text-2xl font-bold uppercase">
                                Cash Book
                            </p>
                        </div>
                    </div>

                    <div
                        onClick={() => handleCalendarModal()}
                        className="flex justify-content-center align-items-center cursor-pointer mx-2"
                    >
                        <img
                            src={"Laundy_App_Icons_Gifs/Other_Icons/schedule.png"}
                            style={{ width: 27 }}
                            alt=""
                        />
                    </div>
                    <div
                        onClick={() => handleSortData()}
                        className="mx-4 cursor-pointer flex align-items-center"
                    >
                        {!sortingData ? (
                            <i
                                className="pi  pi-sort-amount-up-alt"
                                style={{ fontSize: "25px", color: "#fff" }}
                            ></i>
                        ) : (
                            <i
                                className="pi  pi-sort-amount-down"
                                style={{ fontSize: "25px", color: "#fff" }}
                            ></i>
                        )}
                    </div>
                    <div
                        className="flex justify-content-center align-items-center cursor-pointer"
                        onClick={() => setVisible(true)}
                    >
                        <i
                            className="pi pi-bars"
                            style={{ fontSize: "27px", marginRight: 30, color: "#fff" }}
                        ></i>
                    </div>
                </div>
            </div>
            <div
                className="flex gap-3 my-3 mx-3 pb-1 new-scroll-bar"
                style={{
                    overflowX: "auto",
                    whiteSpace: "nowrap",
                }}
            >
                <div className="ml-2 flex justify-content-between  align-items-center">
                    <div>
                        <p className="text-xl font-semibold">Balance : </p>
                    </div>
                </div>

                {renderPaymentModeButtons()}
            </div>
            <div className="  mt-3">
                <div className="my-2 mx-5 flex flex-1">
                    <div className="flex-1">
                        <IconField iconPosition="left" className="flex flex-1">
                            <InputIcon className="pi pi-search text-xl"> </InputIcon>
                            <InputText
                                placeholder={"Search"}
                                value={searchTerm}
                                keyboardType={"default"}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                className="text-xl flex flex-1 py-1 px-5"
                                style={{ borderRadius: 30 }}
                            />
                        </IconField>
                    </div>
                    {searchTerm && (
                        <div
                            className="flex justify-content-center align-items-center mx-2 cursor-pointer"
                            onClick={handleClearSearch}
                        >
                            <div>
                                <p className="text-3xl font-bold " style={{ color: "red" }}>
                                    X
                                </p>
                            </div>
                        </div>
                    )}
                </div>

                {loading ? (
                    <div style={{ flex: 1 }}>
                        <div className="text-center">
                            <ProgressSpinner
                                style={{ width: "70px", height: "70px" }}
                                strokeWidth="4"
                                fill="var(--surface-ground)"
                                animationDuration="2s"
                            />
                        </div>
                    </div>
                ) : filteredOrderInfoData?.length > 0 ? (
                    <div className="mx-4 report-table">{RenderCashBook()}</div>
                ) : (
                    <div className="flex justify-content-center align-items-center">
                        <p className="text-xl font-semi-bold">No Cash Book Found</p>
                    </div>
                )}
            </div>
            <SchedularModal
                schedularModalVisible={analyticsSchedularModalVisible}
                setSchedularModalVisible={setAnalyticsSchedularModalVisible}
                sendDataToOrdersPage={receiveDataFromSchedularModal}
            />
            <StoreSelectionModal
                setStoreSelectionModalVisible={setStoreSelectionModalVisible}
                storeSelectionModalVisible={storeSelectionModalVisible}
                sendDataToOrdersPageFromFilter={receiveDataFromStoreSelectionModal}
                upDateSelectedStore={upDateSelectedStore}
                brandStoreData={brandStoreData}
            />
            <FinanceAdminMenu setVisible={setVisible} visible={visible} />
        </div>
    );
};

export default FinanceCashbook;
